import React, { useState, useRef, useEffect } from "react";
import "./BrokerOTP.css";
import badge from "../../assets/images/badge.png";
import BrokerHeader from "../BrokerHeader/BrokerHeader";
import { useLocation, useNavigate } from "react-router-dom";

const BrokerOTP = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(120); // 2:00 minutes
  const inputRefs = useRef([]);
  const { state } = useLocation();
  const navigate = useNavigate();
  const broker = state?.broker;
  const phoneNumber = state?.phoneNumber || "(+09) 444 222 666";

  useEffect(() => {
    // Focus first input on mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  useEffect(() => {
    // Timer countdown
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleChange = (index, value) => {
    // Only allow numbers
    if (value && !/^\d$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, 6);
    const newOtp = [...otp];

    pastedData.split("").forEach((char, index) => {
      if (index < 6 && /^\d$/.test(char)) {
        newOtp[index] = char;
      }
    });

    setOtp(newOtp);
    // Focus last filled input or last input
    const lastFilledIndex = Math.min(pastedData.length, 5);
    inputRefs.current[lastFilledIndex]?.focus();
  };

  const handleVerify = () => {
    const otpValue = otp.join("");
    if (otpValue.length === 6) {
      console.log("Verifying OTP:", otpValue);
      // API call logic here, then navigate to password screen
      navigate(`/broker-integration/${broker?.name}/password`, {
        state: { broker },
      });
    }
  };

  const handleResendCode = () => {
    setTimer(120);
    setOtp(["", "", "", "", "", ""]);
    inputRefs.current[0]?.focus();
    console.log("Resending OTP...");
    // API call to resend OTP
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")} Sec left`;
  };

  const isOtpComplete = otp.every((digit) => digit !== "");

  return (
    <div className="otp-wrapper">
      <div className="otp-container">
        {/* Top logos section */}
        <BrokerHeader />

        {/* Main Card */}
        <div className="otp-card">
          <h3 className="otp-title">Connect Your Broker</h3>
          

          {/* Security Badge */}
          <div className="otp-secure-badge">
            <div className="otp-secure-info">
              <img src={badge} alt="Secure Badge" className="otp-secure-icon" />
              <span className="otp-secure-text">
                Rest Assured, Your Data is Fully Encrypted
              </span>
            </div>
          </div>
          <div className="otp-message-wrapper">
            <p className="otp-message">
              An authentication code has been sent to
              <br />
              <strong className="otp-phone">{phoneNumber}</strong>
            </p>
          </div>
          {/* OTP Input Boxes */}
          <div className="otp-input-section">
            <div className="otp-inputs" onPaste={handlePaste}>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="otp-input"
                />
              ))}
            </div>
          </div>

          {/* Resend Code */}
          <div className="otp-resend-section">
            <span className="otp-resend-text">I didn't receive code </span>
            {timer > 0 ? (
              <span className="otp-timer">{formatTime(timer)}</span>
            ) : (
              <button className="otp-resend-button" onClick={handleResendCode}>
                Resend Code
              </button>
            )}
          </div>

          {/* Verify Button */}
          <button
            className={`otp-verify-btn ${!isOtpComplete ? "disabled" : ""}`}
            onClick={handleVerify}
            disabled={!isOtpComplete}
          >
            Verify Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrokerOTP;
